import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=7b157f2d&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"
import style0 from "./prescription.vue?vue&type=style&index=0&id=7b157f2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b157f2d",
  null
  
)

export default component.exports